// extracted by mini-css-extract-plugin
module.exports = {"tabRow":"DataSource_tabRow__9NaLw","loaderAnimation":"DataSource_loaderAnimation__1OYpr","helpLink":"DataSource_helpLink__HXAac"};